module.exports = "<exa-weather-kwh-section [customer]=\"customer.selected$ | async\"></exa-weather-kwh-section>\r\n"